export const myNotificationStyles = {
  snackbar: {
    zIndex: 1400,
  },

  alert: {
    minWidth: '320px',
    maxWidth: '450px',
    borderRadius: '12px',
    // Dolu (filled) arka plan + beyaz text — herhangi bir tema arka planinda
    // net okunsun diye kontrast maksimuma cikarildi.
    color: '#ffffff !important',
    boxShadow: '0 6px 20px rgba(0,0,0,0.15)',

    '&.MuiAlert-standardSuccess': {
      backgroundColor: '#2e7d32',
      '& .MuiAlert-icon, & .MuiAlertTitle-root, & .MuiIconButton-root': {
        color: '#ffffff',
      },
    },

    '&.MuiAlert-standardWarning': {
      backgroundColor: '#ed6c02',
      '& .MuiAlert-icon, & .MuiAlertTitle-root, & .MuiIconButton-root': {
        color: '#ffffff',
      },
    },

    '&.MuiAlert-standardError': {
      backgroundColor: '#d32f2f',
      '& .MuiAlert-icon, & .MuiAlertTitle-root, & .MuiIconButton-root': {
        color: '#ffffff',
      },
    },

    '&.MuiAlert-standardInfo': {
      backgroundColor: '#1976d2',
      '& .MuiAlert-icon, & .MuiAlertTitle-root, & .MuiIconButton-root': {
        color: '#ffffff',
      },
    },

    '& .MuiAlert-icon': {
      fontSize: '20px',
      alignItems: 'center',
      padding: '8px 0',
    },

    '& .MuiAlert-message': {
      padding: '8px 0',
      width: '100%',
    },

    '& .MuiAlert-action': {
      padding: '4px 0 4px 16px',
      marginRight: '-4px',
    },
  },

  alertTitle: {
    fontSize: '14px',
    fontWeight: 600,
    marginBottom: '4px',
    lineHeight: 1.2,
  },

  alertMessage: {
    fontSize: '13px',
    lineHeight: 1.4,
    opacity: 0.9,
  },

  closeButton: {
    padding: '4px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
};
